/*
  Holiday gift finder behaviour.
  1. Click tracking: links with data-jd-track publish a Shopify custom event through Shopify.analytics.publish.
     Shopify only passes these to Customer events pixels the shopper has consented to, so no extra script or cookie here.
  2. Date guard: [data-jd-window] blocks carry ISO start/end times. If a cached page is served outside the window,
     the promotional copy is hidden and the evergreen copy (if any) is shown instead.
  3. In-page buttons (href="#...") scroll smoothly and move focus to the target heading.
  4. Holiday signup form (see below).
*/
(function () {
  if (window.jdHolidayReady) return;
  window.jdHolidayReady = true;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-jd-track]');
    if (!a) return;
    var data = {
      event: a.getAttribute('data-jd-track'),
      group: a.getAttribute('data-jd-group') || '',
      label: (a.getAttribute('data-jd-label') || a.textContent || '').trim().slice(0, 80),
      destination: a.getAttribute('href') || '',
      page: location.pathname,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || ''
    };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(data.event, data); } catch (err) {}
  });

  function guard() {
    var now = Date.now();
    document.querySelectorAll('[data-jd-window]').forEach(function (el) {
      var start = Date.parse(el.getAttribute('data-start'));
      var end = Date.parse(el.getAttribute('data-end'));
      var live = (isNaN(start) || now >= start) && (isNaN(end) || now < end);
      if (live) return;
      var promo = el.querySelector('[data-jd-promo]');
      var evergreen = el.querySelector('template[data-jd-evergreen]');
      if (promo) promo.remove();
      if (evergreen) el.appendChild(evergreen.content.cloneNode(true));
      else el.hidden = true;
    });
    document.querySelectorAll('[data-jd-switch]').forEach(function (el) {
      var at = Date.parse(el.getAttribute('data-jd-switch'));
      if (isNaN(at) || now < at) return;
      var next = el.querySelector('template[data-jd-next]');
      if (!next) return;
      el.innerHTML = '';
      el.appendChild(next.content.cloneNode(true));
      el.removeAttribute('data-jd-switch');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"][data-jd-scroll]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var focusEl = target.querySelector('h2') || target;
    if (!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
    focusEl.focus({ preventScroll: true });
    history.replaceState(null, '', '#' + target.id);
  });

  // 4. Holiday signup form ([data-jd-signup]): subscribes the email to an existing Klaviyo list and saves a profile
  //    property (e.g. holiday_early_access_2026 = yes) through Klaviyo's public client API, then opens the confirmation page.
  var KL_REVISION = '2024-10-15';
  function klPost(path, company, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KL_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + path + ' ' + r.status); return r; });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-jd-signup]');
    if (!form) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('.jdh-signup__msg');
    var btn = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();
    function say(text, bad) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!bad);
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say(form.dataset.invalid || 'Please enter a valid email address.', true); input.focus(); return; }
    var company = form.dataset.company;
    var props = {};
    if (form.dataset.prop) props[form.dataset.prop] = form.dataset.value || 'yes';
    if (form.dataset.prop && form.dataset.source) props[form.dataset.prop + '_source'] = form.dataset.source;
    var subscription = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'Website',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
      }
    };
    var profile = { data: { type: 'profile', attributes: { email: email, properties: props } } };
    form.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    say('');
    // The subscription carries consent and the list; the profile call makes sure the property is saved for people
    // who are already subscribed.
    Promise.all([klPost('subscriptions', company, subscription), klPost('profiles', company, profile)])
      .then(function () {
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('jd_early_access_signup', { source: form.dataset.source || '', page: location.pathname });
          }
        } catch (err) {}
        var to = form.dataset.redirect;
        if (to) { location.href = to; return; }
        say('Thank you! You are on the list.');
        form.removeAttribute('aria-busy');
      })
      .catch(function () {
        say(form.dataset.error || 'Something went wrong. Please try again in a moment.', true);
        form.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  });
})();
